export default "__VITE_ASSET__aea837d8__"